"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "heading2" };
var _hoisted_2 = { class: "submission-form__grid-2" };
var _hoisted_3 = ["onClick"];
var _hoisted_4 = ["name", "value"];
var _hoisted_5 = /*#__PURE__*/ vue_2.createElementVNode("div", { class: "checkbox" }, [
    /*#__PURE__*/ vue_2.createElementVNode("i", { class: "termi-circle-checkmark" })
], -1);
exports.default = vue_1.defineComponent({
    props: {
        title: null,
        name: null,
        items: null
    },
    emits: ['update:modelValue'],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        return function (_ctx, _cache) {
            return (vue_2.openBlock(), vue_2.createElementBlock(vue_2.Fragment, null, [
                vue_2.createElementVNode("div", _hoisted_1, vue_2.toDisplayString(props.title), 1),
                vue_2.createElementVNode("div", _hoisted_2, [
                    (vue_2.openBlock(true), vue_2.createElementBlock(vue_2.Fragment, null, vue_2.renderList(props.items, function (item) {
                        return (vue_2.openBlock(), vue_2.createElementBlock("label", {
                            class: "checkbox-radio",
                            onClick: function ($event) { return (emit('update:modelValue', item.value)); }
                        }, [
                            vue_2.createElementVNode("input", {
                                type: "radio",
                                name: props.name,
                                value: item.value
                            }, null, 8, _hoisted_4),
                            _hoisted_5,
                            vue_2.createTextVNode(" " + vue_2.toDisplayString(item.placeholder), 1)
                        ], 8, _hoisted_3));
                    }), 256))
                ])
            ], 64));
        };
    }
});
